import React, {FC, ReactNode} from "react"

import GenericModal from "@irati/ui/src/GenericModal"
import {StyledH4} from "./styled"

interface Props {
  children: ReactNode
  header: ReactNode
  onClose: () => void
  hideHeader?: boolean
}

const HomepageModal: FC<Props> = ({children, header, onClose, hideHeader}) => (
  <GenericModal onExited={onClose} onHide={onClose} show hideActions>
    {!hideHeader && <StyledH4>{header}</StyledH4>}
    {children}
  </GenericModal>
)

export default HomepageModal
